namespace RioERP.Orders {
    export interface OrdersShippingExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class OrdersShippingExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.OrdersShippingExcelImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdersShippingExcelImportForm.init)  {
                OrdersShippingExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(OrdersShippingExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
